import { render, staticRenderFns } from "./AssociateReferentToCompanyModal.vue?vue&type=template&id=bc7d3d84&"
import script from "./AssociateReferentToCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./AssociateReferentToCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports